import { Component, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';

@Component({
  selector: 'app-dashboard-layout',
  standalone: false,
  templateUrl: './dashboard-layout.component.html',
  styleUrl: './dashboard-layout.component.scss'
})
export class DashboardLayoutComponent {
  @ViewChild('sidenav') sidenav!: MatSidenav;

  get isSidebarOpened(): boolean {
    return this.sidenav?.opened ?? false;
  }

  toggleSidebar(): void {
    this.sidenav.toggle();
  }

}
